import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/print.css';
import { applyBrand } from './config/brand.js';
import { App } from './app.js';

applyBrand();

const app = new App();
app.init().catch(e => console.error('[main] init error:', e));
